/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import React from 'react';
import { View, Text, Pressable } from 'react-native';
import { pd } from '@airasia-rn/ui';
import {
  getColor,
  getTextStyle,
} from '@airasia-phoenix/react-native/utils/utils';
import IconView from '@airasia-phoenix/react-native/components/IconView';
import { styles } from './BottomTabWebMobileView.styles';
import type { BottomNavigationData } from '../../models/homepageBlockTypes';

export interface BottomTabWebMobileViewProps {
  data: BottomNavigationData;
  activeNavigationId?: string;
  onActionPress?: (navigationId: string, redirectionUrl: string) => void;
}

const BottomTabWebMobileView: React.FC<BottomTabWebMobileViewProps> = ({
  data,
  activeNavigationId,
  onActionPress,
}) => {
  if (!data.items || data.items.length === 0) return null;

  return (
    <View style={styles.container}>
      {data.items.map((item) => {
        const isActive = item.navigationId === activeNavigationId;
        return (
          <Pressable
            key={item.navigationId}
            style={styles.actionItem}
            onPress={() =>
              onActionPress?.(item.navigationId, item.redirectionUrl)
            }
            accessibilityRole="button"
            accessibilityLabel={item.label}
          >
            <View style={[styles.iconWrapper]}>
              <IconView
                url={item.iconUrl}
                width={28}
                height={28}
                tint={pd.sys.colour.content_secondary.toString()}
              />
            </View>
            <Text
              style={getTextStyle(
                isActive
                  ? pd.sys.typescale.caption_text_medium
                  : pd.sys.typescale.caption_text,
                isActive
                  ? pd.sys.colour.content_primary
                  : pd.sys.colour.content_secondary,
              )}
              numberOfLines={1}
            >
              {item.label}
            </Text>
          </Pressable>
        );
      })}
    </View>
  );
};

export default BottomTabWebMobileView;
